import { render, staticRenderFns } from "./TgCjIndustryVoice.vue?vue&type=template&id=2f84797d&"
import script from "./TgCjIndustryVoice.vue?vue&type=script&lang=js&"
export * from "./TgCjIndustryVoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports